import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';

import iconSrc from '../../../utils/iconSrc';

export const ErrorContainer = styled((props) => (
  <div {...props}>
    <div className={`${props.className}__container`}>
      <SVG
        className={`${props.className}__icon`}
        src={iconSrc('alert-warning')}
        cacheRequests
      />
      <div className={`${props.className}__content`}>{props.children}</div>
    </div>
  </div>
))`
  background: repeating-linear-gradient(
    45deg,
    #fafafa,
    #fafafa 2px,
    #f7f1f1 2px,
    #f7f1f1 4px
  );
  box-shadow: 0px 0px 8px 0px rgba(128, 0, 0, 0.5);
  border-radius: 5px;
  border: 2px solid rgba(255, 0, 0, 1);
  font-family: Consolas, menlo, monospace;
  font-size: 14px;
  margin: 1em 0;
  padding: 1em;
  color: #5a5a5a;

  strong {
    color: #363839;
    font-family: Consolas, menlo, monospace;
  }

  p {
    margin-bottom: 0.25em;
  }

  &__container {
    display: flex;
    align-items: center;
  }

  &__icon {
    fill: #ea232d;
    height: 44px;
    flex-shrink: 0;
  }

  &__content {
    margin-left: 1em;
  }

  ul {
    margin: 0.75em 0;
  }

  li {
    margin: 0;
  }
`;
